export const DEFAULT_PORTFOLIO_NAME = 'New Portfolio';